import request from '../utils/request';
import qs from "qs";

export function getProduct(id) {
    return request({
        url: '/admin/pia/product/'+id,
        method: 'GET',
    })
}
export function getProductList(param) {
    return request({
        url: '/admin/pia/search-product',
        method: 'GET',
        params: param
    })
}

export function saveProduct(id, data) {
    if (id === 0) {
        return request({
            url: '/admin/pia/device',
            method: 'POST',
            data
        })
    }
    return request({
        url: '/admin/pia/'+id+'/product',
        method: 'PUT',
        data
    })
}

export function setProductIsValidate(id, isValidate) {
    return request({
        url: '/admin/pia/'+id+'/product/is-validate/'+isValidate,
        method: 'PUT',
    })
}

export function setProductIsOpen(id, isOpen) {
    return request({
        url: '/admin/pia/'+id+'/product/is-open/' + isOpen,
        method: 'PUT'
    })
}
export function getPiaProduct(id){
    return request({
        url:'/admin/pia-device/'+id+'/products',
        method:'get'
    })
}

export function createPiaQr(data){
    return request({
        url:'/admin/pia-device/products',
        method:'put',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: qs.stringify(data)
    })
}